import React, { useContext, useEffect, useState } from "react";
import GenericDropdown from "../../../GenericComponents/HomeDropDown";
import { NotificationContext } from "../Header";

const FindDropdown: React.FC<{ onHasItemsChange: (status: boolean) => void }> = ({ onHasItemsChange }) => {
    const { FindeMenuItems, WorkspaceMenuState, SetWorkspaceMenuState } = useContext(NotificationContext);
    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        if (FindeMenuItems && FindeMenuItems.length > 0) {
            const newMenuItems = FindeMenuItems.map((item: any) => ({
                content: item.Name,
                Id: item.Id,
                JavascriptTargetParams: item.JavascriptTargetParams,
                Link: item.Links,
                StoredProcParams: item.StoredProcParams,
                Warning: item.Warning,
                MessageResults: item.MessageResults,
                onClick: () => console.log("Find selected:", item.Name),
                className: "popup-menu-items menu-wrapper-find-object-list"
            }));
            setMenuItems(newMenuItems);
            onHasItemsChange(newMenuItems.length > 0);
        } else {
            setMenuItems([]);
            onHasItemsChange(false);
        }
    }, [FindeMenuItems, onHasItemsChange]);

    return (
        <>
            {menuItems.length > 0 && (
                <GenericDropdown
                    id="header_find_object_menu_items_wrapper"
                    containerClass="dropdown-pull-left"
                    toggleClass="noclick"
                    toggleText="Find"
                    menuItems={menuItems}
                    isOpen={WorkspaceMenuState.isFindDropDownOpen} // Manage dropdown state properly
                    onMouseEnter={() => SetWorkspaceMenuState({ ...WorkspaceMenuState, isUserDropDownOpen: false, isWorkspaceDropDownOpen: false, isFindDropDownOpen: true })}
                    onMouseLeave={() => SetWorkspaceMenuState({ ...WorkspaceMenuState, isFindDropDownOpen: false })}
                    isFindMenu={true}
                />
            )}
        </>
    );
};

export default FindDropdown;
